export const TYPE = {
  TOAST: 'toast',
  SNACKBAR: 'snackbar',
  HTML5: 'html5',
};

export const SUBTYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARN: 'warning',
  DEFAULT_SNACKBAR: 'default-snackbar',
};

export const POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center',
};

export const CONSOLE_ERRORS = {
  SETTINGS_TYPE: 'Notification settings must be passed as an object.',
  MISSING_PROPERTY: 'Notification must have at least type and text.',
  UNKNOWN_TYPE: 'Notification of unknown type',
};
